import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

/*
 * Rendered in place of a route's component when the signed-in user does not
 * satisfy that route's `authority` predicate (CPMT-5077).
 *
 * Deliberately says nothing about what the page is or why access was refused —
 * the point of the guard is that a user without the permission learns nothing
 * about the admin surface.
 *
 * Support-mode sessions get different copy. Narvar staff in support mode are
 * refused pages their navigation still offers (tenants, global messages),
 * because those are served only in Narvar's own tenant; telling them to ask
 * their company's administrator would be wrong. The copy does not promise that
 * leaving support mode helps, because a support-mode refusal can also be a
 * missing permission.
 */
const Forbidden = () => {
  const isSupportMode = useSelector(({ userReducer: { user } = {} }) =>
    Boolean(user && user.customerSupportLogin),
  );

  return (
    <div
      style={{
        display: 'flex',
        textAlign: 'center',
        margin: '80px auto',
        flexDirection: 'column',
      }}
    >
      {isSupportMode ? (
        <>
          <h4>You don&apos;t have access to this page in support mode.</h4>
          <p>Some admin pages are only available outside support mode.</p>
        </>
      ) : (
        <>
          <h4>You don&apos;t have access to this page.</h4>
          <p>
            If you think this is a mistake, contact an administrator at your
            company.
          </p>
        </>
      )}
      <p>
        <Link to="/">Go back</Link>
      </p>
    </div>
  );
};

export default Forbidden;
